var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"responsive-container",attrs:{"id":"app"}},[_c('div',{staticClass:"sticky-top bg-dark",staticStyle:{"box-shadow":"rgba(0, 0, 0, 0.05) 0px 1px 2px 0px"}},[_c('Navi')],1),_c('router-view'),_c('div',{staticClass:"bg-dark"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }